






















































































import {Component, Vue, Prop} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Card from '@/components/material/Card.vue';
import ImageUploader from '@/modules/files/_components/imageUploader.vue';

@Component({
  components: {
    ImageUploader,
    Card,
  },
})
export default class EditCampaignArticle extends Vue {
  public $refs!: {
    image: any,
  };

  @Prop(String) private readonly id!: string;
  @Prop(String) private readonly articleId!: string;

  @Action('campaignArticles/upload') private upload!: any;
  @Action('campaignArticles/create') private create!: any;
  @Action('campaignArticles/readOne') private readOne!: any;
  @Action('campaignArticles/update') private update!: any;

  @Getter('campaignArticles/one') private campaignArticle!: any;

  private loading: boolean = false;
  private localArticle: any = {};

  private async created() {
    this.loading = true;
    await this.readOne({id: this.articleId});
    this.localArticle = JSON.parse(JSON.stringify(this.campaignArticle));
    this.loading = false;
  }

  private async updateArticle() {
    this.loading = true;
    const url = await this.$refs.image.doUpload();
    const res = await this.update({...this.localArticle, image: url});
    this.loading = false;
    if (res) {
      this.$router.back();
    }
  }
}
